export default "__VITE_ASSET__d4c6b1eb__"